const toggleConfig = {
    /**
     * Type: string/html
     * Default: "On"
     * Description: Text of the on toggle
     */
    on: 'On',
    /**
     * Type: string/html
     * Default: "Off"
     * Description: Text of the off toggle
     */
    off: 'Off',
    /**
     * Type: string
     * Default: ''
     * Description: Size of the toggle.
     * Possible values are btn-lg, btn-sm, btn-xs.
     */
    size: '',
    /**
     * Type: string
     * Default: "btn-primary"
     * Description: Style of the on toggle.
     * Possible values are btn-default, btn-primary, btn-success, btn-info, btn-warning, btn-danger
     */
    onstyle: 'btn-primary',
    /**
     * Type: string
     * Default: "btn-default"
     * Description: Style of the off toggle.
     * Possible values are btn-default, btn-primary,btn- success, btn-info, btn-warning, btn-danger
     */
    offstyle: 'btn-default',
    /**
     * Type: string
     * Default: ''
     * Description: Appends the value to the class attribute of the toggle.
     * This can be used to apply custom styles. Refer to Custom Styles for reference.
     */
    style: ''
};

export default toggleConfig;